import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class CoChair extends Component {
  render() {
    return (
      <div className="App-body-project" id="cochair-top">
        <h2>CO-CHAIR: A Multi-Party Human-AI Interactional Framework for Collaborative Writing Workshops</h2>

        {/* Quick action buttons */}
        <div className="App-body-project-buttons" style={{justifyContent: 'flex-start', gap: '12px', flexWrap: 'wrap', paddingBottom: '16px'}}>
          <a href="https://dl.acm.org/doi/10.1145/3785651.3831418"><button type="button">📄 CSCW 2026 Demo Abstract</button></a>
          <a href="#demo"><button type="button">🎥 Video</button></a>
        </div>

        <hr style={{border: 0, borderTop: '1px solid #e0e0e0', margin: '20px 0', width: '100%'}} />

        {/* Introduction */}
        <section id="Introduction">
          <h4>Introduction</h4>
          <p>
            Formative feedback provides external input for writers to reflect
            on and revise their writing. Collaborative writing workshops, in which a small 
            group of reviewers jointly critique a paper, traditionally coordinate 
            collaborative learning and discussion between authors and peer reviewers. 
            Introducing AI reviewers into these workshops offers the potential to foster 
            additional developmental and metacognitive learning through evaluating AI feedback. 
            In this demonstration, we present CO-CHAIR (COordinated Collaborative Human-AI Reviews), 
            a human-AI interaction framework which mediates multi-party interactions for writing 
            reflection and revision, enabling writers to receive feedback jointly from peers and 
            expert auditors, as well as from LLM-powered AI reviewers. CO-CHAIR’s design aims to 
            motivate continuous advancement of feedback by encouraging joint reflection on existing 
            feedback, which can be initiated and followed by both humans and AIs.
          </p>
        </section>

        <hr style={{border: 0, borderTop: '1px solid #e0e0e0', margin: '20px 0', width: '100%'}} />

        {/* Demo */}
        <section id="demo">
          <h4>Demo</h4>
          <p>
            Below is a video demonstration of the CO-CHAIR system demo at CSCW 
            2026 showing the multi-party human-AI interactions between a human 
            writer, 2 peer reviewers, a human auditor, 2 AI reviewers, and an
            AI auditor during collaborative human-AI writing workshops.

            The framework can be easily extended to other AI models. For
            example, our recent studies have used Gemini 3.5 Flash. 
          </p>
          <div className="App-body-project-video">
            <iframe
              title="CO-CHAIR Demo Video"
              src="https://drive.google.com/file/d/1VfCvFPKHFlQ4J1ZsYqL2-5cqAJvomZ9j/preview"
              allow="autoplay; fullscreen"
              allowFullScreen
            ></iframe>
          </div>
          <p style={{textAlign: 'center', color: '#707070', fontSize: '15px', paddingTop: '8px'}}>
            Demo video of CO-CHAIR: Multi-Party Human-AI Interaction for Collaborative Writing Workshops
          </p>
        </section> 

        <hr style={{border: 0, borderTop: '1px solid #e0e0e0', margin: '20px 0', width: '100%'}} />

        {/* People */}
        <section id="people">
          <h4>People</h4>
          <p style={{paddingBottom: '12px'}}>
            <strong><a href="https://meredithyoung-ng.github.io/">Meredith Young-Ng</a></strong>:
            Ph.D. student in Computer Science at UC Davis; Graduate Student Researcher (GSR) for the PAIRR project
          </p>
          <p style={{paddingBottom: '12px'}}>
            <strong><a href="https://sites.google.com/view/sophiaminnillo" target="_blank" rel="noopener noreferrer">Sophia Minnillo</a></strong>:
            Assistant Professor-Educator of Composition at University of Cincinnati; previously Postdoc at UC Davis for the PAIRR project
          </p>
          <p style={{paddingBottom: '12px'}}>
            <strong><a href="https://writing.ucdavis.edu/people/cwhithaus" target="_blank" rel="noopener noreferrer">Carl Whithaus</a></strong>:
            Professor of Writing and Rhetoric and Director of the University Writing Program at UC Davis; Principal Investigator (PI) for the PAIRR project
          </p>
          <p style={{paddingBottom: '12px'}}>
            <strong><a href="http://www.haochuanwang.info/" target="_blank" rel="noopener noreferrer">Hao-Chuan Wang</a></strong>:
            Professor of Computer Science at UC Davis; Co-Investigator for the PAIRR project
          </p>
          <p>Other contributors: Bhavya Paleru, Jiaxi Huang, Leia Ray, Jordan Thompson</p>
        </section>

        <hr style={{border: 0, borderTop: '1px solid #e0e0e0', margin: '20px 0', width: '100%'}} />

        {/* Acknowledgments */}
        <section id="acknowledgments">
          <h4>Acknowledgments</h4>
          <p>
            This work is supported by the California Education Learning Lab under the&nbsp;
            <a href="https://writing.ucdavis.edu/pairr" target="_blank"
            rel="noopener noreferrer">PAIRR (Peer and AI Review + Reflection)</a> project grant (Foundation for California Community Colleges under Agreement Number 10587).
            <br/><br/>
            We also would like to thank the students and instructors who have participated in our peer & AI review workshop studies.
          </p>
        </section>

        <hr style={{border: 0, borderTop: '1px solid #e0e0e0', margin: '20px 0', width: '100%'}} />

        {/* Contact */}
        <section id="contact">
          <h4>Contact</h4>
          <p>
            For questions or inquiries regarding the CO-CHAIR framework and system demonstration, please contact:
            <br /><br />
            Meredith Young-Ng &mdash; <a href="mailto:mjyoungng@ucdavis.edu">mjyoungng@ucdavis.edu</a><br />
          </p>
        </section>

        {/* Navigation buttons */}
        <div className="App-body-project-buttons" style={{marginTop: '36px', paddingTop: '24px', borderTop: '1px solid #eaeaea'}}>
          <Link to="/wicshistory">
            <button type="button">&#8249; Previous: WiCS History</button>
          </Link>
          <Link to="/work">
            <button type="button">Back to Portfolio</button>
          </Link>
          <Link to="/portalware">
            <button type="button">Next: Portalware &#8250;</button>
          </Link>
        </div>
      </div>
    );
  }
}

export default CoChair;
